import { ComponentPropsWithoutRef, FC } from 'react';

type CaretLeftProps = ComponentPropsWithoutRef<'svg'>;

export const CaretLeftIcon: FC<CaretLeftProps> = ({ fill, ...props }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="8" viewBox="0 0 4 8" fill="none" {...props}>
            <path d="M3.74115 7.36856L0.355774 4L3.74115 0.631439V7.36856Z" fill={fill ?? 'currentColor'} />
        </svg>
    );
};
